import { createBrowserRouter } from "react-router-dom";
import MainRoutes from "./MainRoutes";
import LoginRoutes from "./LoginRoutes";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoutes from "./PublicRoutes";

const router = createBrowserRouter(
  [
    {
      ...MainRoutes,
      element: <ProtectedRoute>{MainRoutes.element}</ProtectedRoute>,
    },
    LoginRoutes,
    PublicRoutes,
  ],
  {
    basename: "/",
  }
);

export default router;
